module.exports = __webpack_public_path__ + "static/radicle-logo@3x-5639352baea7924695f5fa75dcfebf05.png";